import VehicleConsumptionInfo from "./VehicleConsumptionInfo";

export default VehicleConsumptionInfo;
